var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMuteblue(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_205_17)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.6048 27.44L28.8 15.4427V14.9662C28.8006 14.8006 28.759 14.6374 28.6791 14.4917C28.5991 14.3459 28.4834 14.2221 28.3424 14.1316H28.3263C28.3041 14.1161 28.2809 14.102 28.2567 14.0895L28.2113 14.0684L28.139 14.0368L28.0881 14.0184L28.0159 14H27.9597H27.8847H27.8286H27.6947L27.6118 14.0132C27.5949 14.0119 27.5779 14.0119 27.5609 14.0132L27.4619 14.0421H27.4271C27.3809 14.0576 27.3361 14.077 27.2933 14.1L25.6876 14.9504L22.1765 16.8038C22.1391 16.8251 22.0997 16.8427 22.0588 16.8565C21.9419 16.9014 21.8176 16.9246 21.6921 16.9249H17.0196C16.7494 16.9256 16.4905 17.0315 16.2994 17.2195C16.1083 17.4075 16.0007 17.6622 16 17.928V26.5238C16.0004 26.7176 16.0576 26.9072 16.1649 27.0697C16.2722 27.2323 16.425 27.3609 16.6048 27.44Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.4149 26.8569L22.4 27.9672L23.4149 28.5612L26.7364 30.5263L26.7796 30.5458C26.8054 30.5624 26.8326 30.5764 26.8608 30.5874H26.8912C27.0365 30.6396 27.1909 30.6534 27.342 30.6277C27.493 30.602 27.6363 30.5374 27.7601 30.4394C27.884 30.3413 27.9847 30.2125 28.0542 30.0636C28.1237 29.9147 28.16 29.7498 28.16 29.5826V22.2216V21.6803L23.4149 26.8569Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.7963 14.8046L31.7518 14.7679L31.7257 14.7495L31.6786 14.7154L31.6263 14.6866L31.5687 14.6603L31.5085 14.642H31.4536H31.3829H31.3333C31.3089 14.6394 31.2843 14.6394 31.26 14.642H31.2129C31.1877 14.647 31.1631 14.655 31.1396 14.6656H31.0952C31.0694 14.6761 31.0449 14.6893 31.0219 14.7049L30.9853 14.7233C30.9501 14.7467 30.9176 14.774 30.8885 14.8046V14.8046L16.191 29.5479C16.105 29.6345 16.0451 29.7436 16.0183 29.8628C16.0071 29.9101 16.0009 29.9585 16 30.0071C16.0004 30.1235 16.032 30.2377 16.0916 30.3377L16.1073 30.3666L16.136 30.398C16.1521 30.4225 16.1705 30.4454 16.191 30.4663V30.4663C16.2194 30.4952 16.251 30.5207 16.2852 30.5424L16.3166 30.5633L16.3898 30.6001L16.4317 30.6158L16.5049 30.6368H16.552H16.5886C16.6841 30.6463 16.7806 30.6346 16.871 30.6024C16.9615 30.5702 17.0437 30.5183 17.1119 30.4505L31.812 15.7072C31.9325 15.585 32 15.42 32 15.2481C32 15.0762 31.9325 14.9112 31.812 14.7889L31.7963 14.8046Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.5 22.5C6.5 13.1112 14.1112 5.5 23.5 5.5C32.8888 5.5 40.5 13.1112 40.5 22.5C40.5 31.8888 32.8888 39.5 23.5 39.5C14.1112 39.5 6.5 31.8888 6.5 22.5Z",
    stroke: "white",
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_205_17",
    x: 0,
    y: 0,
    width: 47,
    height: 47,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.00392157 0 0 0 0 0.184314 0 0 0 0 0.960784 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_205_17"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_205_17",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMuteblue);
export default __webpack_public_path__ + "static/media/muteblue.09a8c02aef33a2a2b76adeee0b1ae9a2.svg";
export { ForwardRef as ReactComponent };